/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severityinspection1Inputs */

const en_severityinspection1 = /** @type {(inputs: Severityinspection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspection`)
};

const pt_severityinspection1 = /** @type {(inputs: Severityinspection1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspeção`)
};

/**
* | output |
* | --- |
* | "Inspection" |
*
* @param {Severityinspection1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severityinspection1 = /** @type {((inputs?: Severityinspection1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severityinspection1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severityinspection1(inputs)
	return pt_severityinspection1(inputs)
});
export { severityinspection1 as "severityInspection" }